// Module-level cache for the two Flipper flags that gate the shadow surface.
// The wrapper runs from non-React code (services, utils, legacy date helper)
// so it cannot consume useFeatureFlags() directly. useSyncMomentShadowFlag()
// is mounted once at the top of the React tree (M2.2) and writes both flag
// values into this cache; the runner and the sample sender read from the
// synchronous getters below.

import { useFeatureFlags } from '@common/contexts/feature-flags';
import { useEffect } from 'react';

let cachedShadow = false;
let cachedMatchSamples = false;

export function setShadowEnabled(value: boolean): void {
  cachedShadow = value;
}

export function setMatchSamplesEnabled(value: boolean): void {
  cachedMatchSamples = value;
}

export function getShadowEnabled(): boolean {
  return cachedShadow;
}

export function getMatchSamplesEnabled(): boolean {
  return cachedMatchSamples;
}

// The flag keys are registered in M2.1; until that PR lands, useFeatureFlags()'s
// return type does not include them. The cast keeps M3.1 self-contained — the
// runtime read defaults to false when the property is absent.
type ShadowFlagsShapeType = {
  isMomentShadowModeEnabled?: boolean;
  isMomentShadowMatchSamplesEnabled?: boolean;
};

export function useSyncMomentShadowFlag(): void {
  const flags = useFeatureFlags() as unknown as ShadowFlagsShapeType;
  const shadow = flags.isMomentShadowModeEnabled ?? false;
  const samples = flags.isMomentShadowMatchSamplesEnabled ?? false;

  useEffect(() => {
    setShadowEnabled(shadow);
    setMatchSamplesEnabled(samples);
  }, [shadow, samples]);
}
